import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { bomItemSelector } from './bomItemSelector'

export const bomItemFileNameSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(
      state,
      bomItemId,
      state.project.currentView === ProjectViews.AssemblyHierarchy
    )

    if (!bomItem) {
      return null
    }

    if (bomItem.type === 'MaterialHeader' || bomItem.type === 'RoutingHeader') {
      throw Error('material header does not have file name')
    }

    return bomItem.originalFileName || ''
  }
